import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'print' })
export class PrintPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log(value)
    return value
  }

}
